import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { log } from "@/utilities/logging"
import welcomeTokenStorage from "@/utilities/WelcomeTokenStorage"

export const Route = createFileRoute("/qr/$qrLookupID/passes/$epoch")({
  beforeLoad: async ({ params }) => {
    // Validate epoch from URL - prevent access to old sessions
    const isValidEpoch = welcomeTokenStorage.validateEpochFromUrl({
      epoch: params.epoch,
      flow: "passes",
    })
    if (!isValidEpoch) {
      log({
        level: "warn",
        flow: "passes",
        scope: "guard.epoch",
        message: "Invalid epoch, redirecting to /welcome",
      })
      throw redirect({ to: "/qr/$qrLookupID/welcome", params })
    }
  },
  component: Outlet,
})
